import React from 'react'
import Liste from './Liste'

const junior = () => {
  return (
    <div>
        <Liste page="junior"/>
    </div>
  )
}

export default junior